import Card from "@mui/material/Card"
import Grid from "@mui/material/Grid"
import Icon from "@mui/material/Icon"
import MDBox from "components/MDBox"
import MDButton from "components/MDButton"
import MDPagination from "components/MDPagination"
import config from "config"
import Footer from "monitor/Footer"
import DashboardLayout from "monitor/LayoutContainers/DashboardLayout"
import DashboardNavbar from "monitor/Navbars/DashboardNavbar"
import DataTable from "monitor/Tables/DataTable"
import { useEffect, useState } from "react"
import { Link, useNavigate } from "react-router-dom"
import Chip from "@mui/material/Chip"

import Swal from "sweetalert2"
import { showToast } from "utils/swalToast"
import MDTypography from "components/MDTypography"
import { FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material"

function Sucursales() {
  const [data, setData] = useState([])
  const [empresas, setEmpresas] = useState([])
  const [selectedEmpresas, setSelectedEmpresas] = useState("")
  const [nombre, setNombre] = useState("")
  const [currentPage, setCurrentPage] = useState(0)
  const [totalPages, setTotalPages] = useState(0)
  const [totalElements, setTotalElements] = useState(0)

  const navigate = useNavigate()

  const columns = [
    { Header: "Item", accessor: "item", width: "5%" },
    { Header: "Nombre", accessor: "descripcion", width: "15%" },
    { Header: "Empresa", accessor: "empresa.descripcion", width: "15%" },
    { Header: "Código de Evento", accessor: "codigoEvento", width: "10%" },
    { Header: "Activo", accessor: "activo", width: "10%" },
    { Header: "Acciones", accessor: "action", align: "center", width: "10%" },
  ]

  const fetchSucursales = async (page = 0) => {
    try {
      let url = `${config.api.baseURL}/sucursales?page=${page}`

      if (selectedEmpresas) {
        url += `&empresaId=${encodeURIComponent(selectedEmpresas)}`
      }
      if (nombre) {
        url += `&nombre=${encodeURIComponent(nombre)}`
      }

      const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      if (response.status === 200) {
        const result = await response.json()
        const rows = addColumns(result.content ?? result, page)
        setData(rows)
        setCurrentPage(result.page ?? page)
        setTotalPages(result.totalPages ?? 1)
        setTotalElements(result.totalElements ?? rows.length)
      }
    } catch (error) {
      console.error("Error fetching data:", error)
    }
  }

  const handleBuscar = async () => {
    setCurrentPage(0)
    await fetchSucursales(0)
  }

  const handlePageChange = (page) => {
    setCurrentPage(page)
    fetchSucursales(page)
  }

  function addColumns(dataColumns, page = 0) {
    let c = page * 10
    dataColumns.map((d) => {
      d.action = (
        <MDBox>
          <MDButton
            sx={{ mr: 1 }}
            variant="gradient"
            color="success"
            iconOnly
            onClick={() => handleEdit(d.idSucursal)}
          >
            <Icon>edit</Icon>
          </MDButton>
          <MDButton
            sx={{ mr: 1 }}
            variant="gradient"
            color="warning"
            iconOnly
            onClick={() => handleServices(d.idSucursal)}
          >
            <Icon>miscellaneous_services_icon</Icon>
          </MDButton>
          <MDButton
            sx={{ mr: 1, backgroundColor: "#3f51b5", color: "#fff", "&:hover": { backgroundColor: "#32408f" } }}
            variant="gradient"
            iconOnly
            onClick={() => handleDiccionario(d.idSucursal)}
          >
            <Icon>tune</Icon>
          </MDButton>
          <MDButton
            variant="gradient"
            color="error"
            iconOnly
            onClick={() => handleDelete(d.idSucursal)}
          >
            <Icon>delete</Icon>
          </MDButton>
        </MDBox>
      )
      d.activo
        ? (d.activo = <Chip label="Si" color="success" variant="outlined" />)
        : (d.activo = <Chip label="No" color="error" variant="outlined" />)
      d.item = ++c
    })
    return dataColumns
  }

  const getEmpresas = async () => {
    try {
      let empUrl = `${config.api.baseURL}/empresas`
      const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))
      const response = await fetch(empUrl, {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      })

      if (response.status === 200) {
        const result = await response.json()
        if (result) {
          setEmpresas(result)
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error)
    }
  }

  function handleDelete(id) {
    Swal.fire({
      title: "¿Está seguro que desea eliminar este sucursal?",
      text: "¡No podrás revertir esta acción!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        // El usuario confirmó la eliminación, realizar la solicitud DELETE
        let url = `${config.api.baseURL}/sucursales/${id}`
        const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))

        fetch(url, {
          method: "DELETE",
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        })
          .then((response) => {
            if (response.status === 200) {
              showToast({ title: "Sucursal eliminado exitosamente", icon: "success" })
              fetchSucursales(currentPage)
            } else {
              showToast({
                icon: "error",
                title: "Error",
                text: response.body.error || "No se pudo eliminar la sucursal.",
              })
            }
          })
          .catch((error) => {
            const err = error.message
            showToast({ icon: "error", title: "Error", text: err })
          })
      }
    })
  }

  const resetValues = () => {
    setSelectedEmpresas("")
    setNombre("")
  }

  const handleClearFilters = () => {
    resetValues() // Reset all filter states
  }

  function handleEdit(id) {
    navigate(`/sucursales/${id}`)
  }

  function handleServices(id) {
    navigate(`/sucursales/${id}/servicios`)
  }

  function handleDiccionario(id) {
    navigate(`/sucursales/${id}/diccionario`)
  }

  const handleNombreSearch = (event) => {
    const term = event.target.value
    setNombre(term)
  }

  useEffect(() => {
    fetchSucursales(0)
    getEmpresas()
  }, [])

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={5} pb={3}>
        <Grid container>
          <Grid item xs={12}>
            <Card sx={{ p: 2, mb: 3 }}>
              <MDTypography variant="h6" color="text" gutterBottom>
                Filtros
              </MDTypography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={4}>
                  <FormControl fullWidth>
                    <InputLabel>Empresa</InputLabel>
                    <Select
                      label="Empresa"
                      variant="outlined"
                      fullWidth
                      value={selectedEmpresas}
                      onChange={(e) => setSelectedEmpresas(e.target.value)}
                      sx={{ p: 1.5 }}
                      placeholder="Seleccione.."
                    >
                      <MenuItem value="">Ninguna</MenuItem>
                      {empresas.map((emp) => (
                        <MenuItem key={emp.idEmpresa} value={emp.idEmpresa}>
                          {emp.descripcion}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <TextField
                    label="Nombre"
                    variant="outlined"
                    fullWidth
                    value={nombre}
                    onChange={handleNombreSearch}
                    onKeyDown={(event) => {
                      if (event.key === "Enter") {
                        handleNombreSearch(event)
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <MDBox display="flex" justifyContent="space-between" alignItems="center" mt={2}>
                    <MDBox>
                      <MDButton
                        type="submit"
                        variant="gradient"
                        color="info"
                        onClick={handleBuscar}
                      >
                        Buscar
                      </MDButton>
                      &nbsp;
                      <MDButton
                        type="button"
                        variant="outlined"
                        color="info"
                        onClick={handleClearFilters}
                      >
                        Limpiar
                      </MDButton>
                    </MDBox>

                    <Link to="/sucursales/agregar" style={{ textDecoration: "none" }}>
                      <MDButton type="button" variant="gradient" color="success">
                        Agregar
                      </MDButton>
                    </Link>
                  </MDBox>
                </Grid>
              </Grid>
            </Card>
          </Grid>
          <Grid item xs={12}>
            <MDBox>
              <Card sx={{ p: 2 }}>
                <DataTable
                  isSorted={false}
                  noEndBorder
                  showTotalEntries={false}
                  entriesPerPage={false}
                  pagination={false}
                  canSearch={false}
                  table={{
                    columns: columns,
                    rows: data,
                  }}
                />
                {totalPages > 1 && (
                  <MDBox
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    px={3}
                    pb={2}
                    pt={2}
                  >
                    <MDTypography variant="caption" color="secondary">
                      Mostrando {currentPage * 10 + 1}–{Math.min((currentPage + 1) * 10, totalElements)} de {totalElements} registros
                    </MDTypography>
                    <MDPagination variant="gradient" color="info">
                      <MDPagination item onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 0}>
                        <Icon sx={{ fontWeight: "bold" }}>chevron_left</Icon>
                      </MDPagination>
                      {Array.from({ length: totalPages }, (_, i) => (
                        <MDPagination
                          item
                          key={i}
                          active={currentPage === i}
                          onClick={() => handlePageChange(i)}
                        >
                          {i + 1}
                        </MDPagination>
                      ))}
                      <MDPagination item onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages - 1}>
                        <Icon sx={{ fontWeight: "bold" }}>chevron_right</Icon>
                      </MDPagination>
                    </MDPagination>
                  </MDBox>
                )}
              </Card>
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  )
}

export default Sucursales
